var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConTwitterIcn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "con_twitter_icn",
    transform: "translate(-69.912 1)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-logo-twitter",
    "data-name": "Icon ionic-logo-twitter",
    d: "M27.413,7.107a10.464,10.464,0,0,1-3.063.877A5.533,5.533,0,0,0,26.7,4.912a10.357,10.357,0,0,1-3.388,1.346,5.235,5.235,0,0,0-3.9-1.759,5.445,5.445,0,0,0-5.333,5.552,5.637,5.637,0,0,0,.138,1.266,14.934,14.934,0,0,1-11-5.8A5.723,5.723,0,0,0,2.5,8.3a5.623,5.623,0,0,0,2.38,4.623,5.059,5.059,0,0,1-2.424-.693V12.3a5.5,5.5,0,0,0,4.281,5.443,5.177,5.177,0,0,1-1.4.195,4.846,4.846,0,0,1-1-.1,5.374,5.374,0,0,0,4.986,3.856,10.384,10.384,0,0,1-7.9,2.3A14.5,14.5,0,0,0,9.579,26.5c9.824,0,15.19-8.462,15.19-15.8,0-.241-.006-.481-.017-.716A11.11,11.11,0,0,0,27.413,7.107Z",
    transform: "translate(68.499 -5.5)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConTwitterIcn);
export default __webpack_public_path__ + "static/media/con_twitter_icn.8ccd92203a580d1b274f21c6ff20d569.svg";
export { ForwardRef as ReactComponent };